<template>
  <div class="row">
    <div
      v-if="joistMaterial === 'softwood' || joistMaterial === 'hardwood'"
      class="col-12 text-center"
    >
      <div
        class="btn-group btn-group-toggle btn-group-sm mb-2"
        data-toggle="buttons"
      >
        <label
          class="btn btn-primary text-nowrap"
          :class="{active: thick == '12-19'}"
        >
          <input
            type="radio"
            value="12-19"
            @click="$emit('set-thick',$event.target.value)"
          >12-&lt;19mm
        </label>
        <label
          class="btn btn-primary text-nowrap"
          :class="{active: thick == '19'}"
        >
          <input
            type="radio"
            value="19"
            @click="$emit('set-thick',$event.target.value)"
          >19mm
        </label>
        <label
          class="btn btn-primary text-nowrap"
          :class="{active: thick == '19-24'}"
        >
          <input
            type="radio"
            value="19-24"
            checked
            @click="$emit('set-thick',$event.target.value)"
          > 19-24mm
        </label>
      </div>
    </div>
    <div
      v-if="joistMaterial === 'softwood' || joistMaterial === 'hardwood'"
      class="col-12 text-center"
    >
      <div
        class="btn-group btn-group-toggle btn-group-sm"
        data-toggle="buttons"
      >
        <label
          class="btn btn-primary text-nowrap"
          :class="{active: thick == '24-28'}"
        >
          <input
            type="radio"
            value="24-28"
            @click="$emit('set-thick',$event.target.value)"
          > 24-28mm
        </label>
        <label
          class="btn btn-primary text-nowrap"
          :class="{active: thick == '28-32'}"
        >
          <input
            type="radio"
            value="28-32"
            @click="$emit('set-thick',$event.target.value)"
          > 28-32mm
        </label>
        <label
          class="btn btn-primary text-nowrap"
          :class="{active: thick == '32+'}"
        >
          <input
            type="radio"
            value="32+"
            @click="$emit('set-thick',$event.target.value)"
          > 32mm+
        </label>
      </div>
    </div>
    <div
      v-if="joistMaterial === 'steel'"
      class="col-12 text-center"
    >
      <div
        class="btn-group btn-group-toggle btn-group-sm mb-2"
        data-toggle="buttons"
      >
        <label
          class="btn btn-primary text-nowrap"
          :class="{active: thick == '16-22'}"
        >
          <input
            type="radio"
            value="16-22"
            @click="$emit('set-thick',$event.target.value)"
          >16-22mm
        </label>
        <label
          class="btn btn-primary text-nowrap"
          :class="{active: thick == '35-50'}"
        >
          <input
            type="radio"
            value="35-50"
            @click="$emit('set-thick',$event.target.value)"
          >35-50mm
        </label>
      </div>
    </div>
    <div
      v-if="joistMaterial === 'aluminium'"
      class="col-12 text-center"
    >
      <div
        class="btn-group btn-group-toggle btn-group-sm mb-2"
        data-toggle="buttons"
      >
        <label
          class="btn btn-primary text-nowrap"
          :class="{active: thick == '16-20'}"
        >
          <input
            type="radio"
            value="16-20"
            @click="$emit('set-thick',$event.target.value)"
          >16-20mm
        </label>
        <label
          class="btn btn-primary text-nowrap"
          :class="{active: thick == '20-24'}"
        >
          <input
            type="radio"
            value="20-24"
            @click="$emit('set-thick',$event.target.value)"
          >>20-24mm
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThicknessButtons',
  props: {
    joistMaterial: {
      type: String,
      default: 'softwood',
    },
    thick: {
      type: String,
      default: '19',
    },
  },
};
</script>
